import React from "react";
import PropTypes from "prop-types";

import { OrderObject } from "./../Queries/OrderQuery";

import AidacareStaffQuery from "./AidacareStaffQuery";
import AssignUpdater from "./AssignUpdater";
import ToStaffMember from "./ToStaffMember";

class ReassignStaffMemberIndex extends React.Component {
  render() {
    const { order, complete } = this.props;

    return (
      <AidacareStaffQuery
        orderId={order.id}
        render={({ staffMembers }) => {
          const sortedStaff = staffMembers.toSorted((a, b) => a.name.localeCompare(b.name));
          const shouldSplit = sortedStaff.length > 15;
          const midPoint = sortedStaff.length / 2;
          const firstHalf = shouldSplit ? sortedStaff.slice(0, midPoint) : sortedStaff;
          const secondHalf = shouldSplit ? sortedStaff.slice(midPoint) : [];

          return (
            <div className="assign-staff-member-to-order">
              <ul className="assign-staff-member-to-order-list">
                {firstHalf.map(staff => (
                  <li key={staff.id}>
                    <AssignUpdater
                      order={order}
                      staff={staff}
                      complete={complete}
                      render={props => <ToStaffMember {...props} />}
                    />
                  </li>
                ))}
              </ul>
              {shouldSplit && (
                <ul className="assign-staff-member-to-order-list">
                  {secondHalf.map(staff => (
                    <li key={staff.id}>
                      <AssignUpdater
                        order={order}
                        staff={staff}
                        complete={complete}
                        render={props => <ToStaffMember {...props} />}
                      />
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        }}
      />
    );
  }
}

ReassignStaffMemberIndex.propTypes = {
  order: OrderObject,
  complete: PropTypes.func
};

export default ReassignStaffMemberIndex;
